// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Stepper (− Wert +), portiert aus docs/referenz/trainingslog.html
import { useEffect, useRef } from "react"
import { step as stepBy } from "@/lib/sets"

export default function SetStepper({ value, step, onChange }: {
  value: number
  step: number
  onChange: (v: number) => void
}) {
  const inputRef = useRef<HTMLInputElement>(null)
  const prev = useRef(value)

  // Mini-Hüpfer der Zahl bei jeder Änderung (Skill §10): Klasse ab, Reflow, Klasse wieder dran
  useEffect(() => {
    if (prev.current === value) return
    prev.current = value
    const el = inputRef.current
    if (!el) return
    el.classList.remove("hop")
    void el.offsetWidth
    el.classList.add("hop")
  }, [value])

  return (
    <div className="stepper">
      <button type="button" aria-label="weniger" onClick={() => onChange(stepBy(value, -step))}>−</button>
      <input
        ref={inputRef}
        type="number"
        inputMode="decimal"
        min={0}
        step={step}
        value={value}
        onChange={(e) => onChange(parseFloat(e.target.value) || 0)}
      />
      <button type="button" aria-label="mehr" onClick={() => onChange(stepBy(value, step))}>+</button>
    </div>
  )
}
